import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=c6e47060&lang=css"

const __exports__ = script;

export default __exports__